import * as THREE from 'three'
import Experience from '../../Experience.js'
import Sphere from './Sphere.js'
import gsap from 'gsap'

export default class LuxurySphere extends Sphere {
  constructor(interactive) {
    super()
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.time = this.experience.time
    this.debug = this.experience.debug
    this.environment = this.experience.world.environment
    this.scene.environmentIntensity = 0.1
    this.params = {
      color: new THREE.Color('#878787').convertLinearToSRGB(),
      transparent: true,
      ior: 1.09,
      side: THREE.DoubleSide,
      transmission: 0.99,
      roughness: 0.32,
      metalness: 0.0,
      thickness: 0.88,
      // envMapIntensity: 0.0,
      clearcoat: 0.16,
      clearcoatRoughness: 1,
    }
    this.interactive = interactive;
    this.glassMaterial = new THREE.MeshPhysicalMaterial({
      color: new THREE.Color('white').convertLinearToSRGB(),
      transparent: true,
      ior: this.params.ior,
      side: THREE.DoubleSide,
      transmission: this.params.transmission,
      roughness: this.params.roughness,
      clearcoat: this.params.clearcoat,
      clearcoatRoughness: this.params.clearcoatRoughness,
      metalness: this.params.metalness,
      thickness: this.params.thickness,
      opacity: 0.0,

      // envMapIntensity: this.params.envMapIntensity,
    });
    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder('sphere')
      this.debugFolder.add(this.params, 'transmission').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
      this.debugFolder.add(this.params, 'ior').min(1).max(2).step(0.01).onChange(this.updateMaterial.bind(this))
      this.debugFolder.add(this.params, 'thickness').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
      this.debugFolder.add(this.params, 'roughness').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
      this.debugFolder.add(this.params, 'metalness').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
      // this.debugFolder.add(this.params, 'envMapIntensity').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
      this.debugFolder.add(this.params, 'clearcoat').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
      this.debugFolder.add(this.params, 'clearcoatRoughness').min(0).max(1).step(0.01).onChange(this.updateMaterial.bind(this))
    }

    // Resource
    this.resource = this.resources.items.sphereModel

    this.setModel()
    this.sizeMultiplier = 1.025
    this.center = this.setSphereCenter()
    this.radius = this.getRadius() - 0.15
    this.setAxes()

    this.fog.show()

    this.axes.show()
    this.show()
    this.experience.world.texts.forEach(text => {
      text.show()
    })
    this.rotateIn()

  }
  show() {
    gsap.to(this.glassMaterial, {
      opacity: 1.0,
      duration: 2.0,
      delay: 0.5,
      ease: 'power2.inOut',
      onUpdate: () => {
        this.mesh.traverse((child) => {
          if (child.material && child.name === 'Glass') {
            child.material.opacity = this.glassMaterial.opacity
          }
        })
      },
      onComplete: () => {
        if (this.experience.interactive) {
          this.fog.animateToPosition(2, new THREE.Vector3(0, this.center.y, 0))
        }
      }
    })
  }
  updateMaterial() {
    // this.glassMaterial.color = this.params.color
    this.glassMaterial.transparent = this.params.transparent
    this.glassMaterial.ior = this.params.ior
    this.glassMaterial.transmission = this.params.transmission
    this.glassMaterial.roughness = this.params.roughness
    this.glassMaterial.metalness = this.params.metalness
    // this.glassMaterial.envMapIntensity = this.params.envMapIntensity
    this.glassMaterial.clearcoat = this.params.clearcoat
    this.glassMaterial.clearcoatRoughness = this.params.clearcoatRoughness
    this.glassMaterial.thickness = this.params.thickness
    // this.glassMaterial.alphaMap = this.glassMaterial.map

    this.mesh.traverse((child) => {
      if (child.material && child.name === 'Glass') {
        const map = child.material.map
        child.material = this.glassMaterial.clone()
        child.material.map = map
      }
    })
  }
  setModel() {
    this.mesh = this.resource.scene

    this.mesh.scale.set(0.2, 0.2, 0.2)
    this.mesh.position.set(-0, 1, 0)
    this.scene.add(this.mesh)
    let remove = []
    this.mesh.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true
        if (child.material && child.name !== 'Plane') {
          if (child.name.includes('Group') === false) {
            remove.push(child)
          }
          const map = child.material.map

          child.material = this.glassMaterial.clone()
          child.material.map = map
          child.name = 'Glass'

        }
        if (child.geometry) {

          if (child.name === 'Plane') {
            remove.push(child)
            child.material = new THREE.MeshBasicMaterial({
              color: 0x111111,
              side: THREE.DoubleSide,
              transparent: true,
              opacity: 0.0
            })
            child.visible = false;
          }
        }
      }
    })
    remove.forEach(child => {
      child.removeFromParent();
    })
    this.experience.world.environment.environmentMap.updateMaterials()
  }

  update() {
    super.update()
  }
}